module.exports = __webpack_public_path__ + "img/initial-deposit.6d4f9aac.png";